<template>
  <vue-final-modal
    :value="visible"
    name="loginform-dialog"
    :classes="['loginform-dialog__container']"
    :content-class="['loginform-dialog__content', 'v--modal-box', 'v--modal']"
    :click-to-close="true"
    :lock-scroll="true"
    attach="body"
    @input="onVisibleInput"
  >
    <div
      class="v--modal-close-top"
      v-loading.fullscreen.lock="fullscreenLoading"
    >
      <el-button
        @click="closeLoginformDialog"
        icon="el-icon-circle-close"
        style="font-size: 2rem"
        type="text"
      ></el-button>
    </div>
    <div style="display: inline-block; min-width: 100%; text-align: center">
      <div style="display: inline-block; min-width: 100%; text-align: center">
        <p style="font-size: 140%">
          <img
            src="/static/renew_img/bnr/mypage_top_banner_quickmail_20230222.png"
            style="width: 90%"
          />
        </p>
      </div>
      <div style="padding: 20px 0; font-size: 70%">
        Yagishの<router-link
          id="footer-link-terms"
          :to="{ name: 'termsPage' }"
          target="_blank"
          >利用規約</router-link
        >、<router-link
          id="footer-link-terms"
          :to="{ name: 'policyPage' }"
          target="_blank"
          >個人情報の取り扱い</router-link
        >について<br />
        に同意の上、ログインしてください。
      </div>
      <div class="text-center">
        <LoginForms />
      </div>
    </div>
  </vue-final-modal>
</template>

<script setup lang="ts">
/**
 * クイックメール等のログイン誘導（vue-final-modal）。
 * open は mitt（open-loginform-dialog）。未移行 hub 発火は emitter の hub→mitt forward。
 */
import { onBeforeMount, onBeforeUnmount, ref } from 'vue'
import { useEventListener } from '@vueuse/core'
import { emitter } from '@/plugins/emitter'
import LoginForms from '@/components/auth/LoginSpecialForms.vue'

const OPEN_LOGINFORM_DIALOG = 'open-loginform-dialog'

const visible = ref(false)
const fullscreenLoading = ref(false)

function openLoginformDialog() {
  visible.value = true
}

function closeLoginformDialog() {
  visible.value = false
}

function onVisibleInput(value: boolean) {
  visible.value = value
}

onBeforeMount(() => {
  emitter.on(OPEN_LOGINFORM_DIALOG, openLoginformDialog)
})

onBeforeUnmount(() => {
  emitter.off(OPEN_LOGINFORM_DIALOG, openLoginformDialog)
})

useEventListener(window, 'popstate', closeLoginformDialog)
</script>

<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>

<style lang="scss" scoped>
.text-center {
  text-align: center;
}

.v--modal-close-top {
  position: absolute;
  right: 0;
  top: 0;
}
</style>

<style lang="scss">
.loginform-dialog__container {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 20px 16px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  z-index: 1001;
}

.loginform-dialog__content.v--modal-box.v--modal {
  position: relative;
  box-sizing: border-box;
  flex: 0 0 auto;
  width: calc(100% - 32px);
  max-width: 600px;
  margin-block: auto;
  border-radius: 8px;
  padding: 20px;
  background: #fff;
}

@media screen and (width <= 640px) {
  .loginform-dialog__content.v--modal-box.v--modal {
    padding: 24px;
  }
}
</style>
